import { faClock } from '@fortawesome/free-solid-svg-icons/faClock'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useCallback, useState, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { CityList, ImgRow } from '../../generic'
import SimpleIcon from '../../generic/components/SimpleIcon'
import { isUserStaff } from '../../user/store/selectors'
import PropTypesHelpers from '../../utils/propTypesHelpers'

export const cityItemsProp = (stadt = '', location = '') => {
  const cityItems = stadt.split(/\s*,\s*/).filter(city => city.length)
  if (location) {
    const searchedLocation = location.trim().toUpperCase()
    const locationIdx = cityItems.findIndex(i => i.toUpperCase().includes(searchedLocation))
    if (locationIdx >= 0) {
      return [cityItems[locationIdx]]
    }
  }
  return cityItems
}

export const JobHeaderView = (
  {
    jobInfo: {
      stand: {
        logo,
        name: companyName,
        url: companyProfileUrl
      },
      name,
      date_str: dateString,
      search_debug: searchDebug,
      stadt,
      highlight,
      kununu
    },
    className,
    isInfoBox,
    titleTag: Title = 'h5',
    searchQuery: {
      location
    } = {},
    dateIcon,
    withKununuScore = true
  }
) => {
  const cityItems = useMemo(() => cityItemsProp(stadt, location), [stadt, location])
  const hasSearchDebug = useSelector(isUserStaff) && searchDebug != null
  const [debugVisible, setDebugVisible] = useState(false)
  const toggleDebug = useCallback((e) => {
    if (!hasSearchDebug) return
    e.preventDefault()
    e.stopPropagation()
    setDebugVisible(!debugVisible)
  }, [hasSearchDebug, debugVisible, setDebugVisible])

  return (
    <div className={classnames('job-header', className)}>
      <ImgRow src={logo} alt={companyName} className='logo' kununu={kununu} withKununuScore={withKununuScore}>
        {Boolean(highlight) && (
          <div className='row-premium'>
            <span className='top-offer'>Premium</span>
          </div>
        )}
        <div className='row-header qa-company-info'>
          {companyProfileUrl && isInfoBox
            ? <a href={companyProfileUrl} target='_blank' rel='noopener noreferrer'>{companyName}</a>
            : companyName}
        </div>
        <Title className='text-multi-truncate w-100 row-title'>{name}</Title>
        <CityList queryKey='pl' items={cityItems} itemProps={{ tag: 'span' }} />
        <div className='row-footer' onClick={toggleDebug}>
          <SimpleIcon icon={dateIcon || faClock} className='d-xl-none mr-1' />
          <span>{dateString}</span>
        </div>
        {debugVisible && hasSearchDebug &&
          <pre className='row-debug'>{searchDebug}</pre>}
      </ImgRow>
    </div>
  )
}

JobHeaderView.propTypes = {
  className: PropTypesHelpers.classnames,
  isInfoBox: PropTypes.bool,
  jobInfo: PropTypes.shape({
    name: PropTypes.string.isRequired,
    date_str: PropTypes.string.isRequired,
    stand: PropTypes.shape({
      logo: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string
    }).isRequired,
    search_debug: PropTypes.string,
    stadt: PropTypes.string,
    highlight: PropTypes.bool,
    kununu: PropTypes.shape({
      score: PropTypes.number
    })
  }).isRequired,
  searchQuery: PropTypes.shape({
    location: PropTypes.string
  }),
  dateIcon: PropTypes.object,
  titleTag: PropTypes.node,
  withKununuScore: PropTypes.bool
}

export default JobHeaderView
